export const PRICE = "PRICE";
export const NAME = "NAME";
export const ASCENDING = "ASCENDING";
export const DESCENDING = "DESCENDING";

export const ALL_PRODUCTS = "ALL_PRODUCTS";
export const SOLID_FUEL_BOILERS = "SOLID_FUEL_BOILERS";
export const PELLET_BOILERS = "PELLET_BOILERS";
export const INDUSTRIAL_BOILERS = "INDUSTRIAL_BOILERS";
export const BOILERS = "BOILERS";
export const BURNERS = "BURNERS";
export const ACCESORIES = "ACCESORIES";
export const PROMOTIONS = "PROMOTIONS";

export const initialList = [
  4, 19, 7, 20, 18, 9, 1, 2, 3, 5, 6, 8, 10, 11, 12, 16, 17, 21, 22, 0, 13, 14,
  15,
];

export const allProducts = [
  {
    id: 0,
    name: "Arzator Altep",
    price: 6969,
    image: "/products/0.png",
    type: [BURNERS],
    promotion: false,
    prices: [
      { power: "20KW", price: 6969 },
      { power: "30KW", price: 7635 },
      { power: "40KW", price: 8558 },
      { power: "50KW", price: 9173 },
      { power: "65KW", price: 10910 },
      { power: "80KW", price: 13273 },
      { power: "100KW", price: 15194 },
      { power: "150KW", price: 18961 },
      { power: "200KW", price: 24599 },
      { power: "250KW", price: 28958 },
      { power: "300KW", price: 33669 },
    ],
    images: [
      "/assets/ProductImages/0/1.jpg",
      "/assets/ProductImages/0/2.jpg",
      "/assets/ProductImages/0/3.jpg",
    ],
    price_details: false,
    short_description: false,
    parameters: [
      {
        icon: "fas fa-bolt fa-lg",
        name: "Putere",
        stars: 5,
        details: "20 kW - 300 kW",
      },
      {
        icon: "fas fa-star fa-lg",
        name: "Oțel de înaltă calitate",
        stars: 5,
        details: "Oțel inoxidabil",
      },
      {
        icon: "fa-solid fa-microchip fa-lg",
        name: "Сontrol Smart",
        stars: 5,
        details: "Control Automat / GSM / Wi-Fi",
      },
      {
        icon: "fas fa-tachometer-alt fa-lg",
        name: "Eficiență",
        stars: 5,
        details: "Minimum - 93%",
      },
    ],
    warranty_details: false,
    tabsInfo: [true, false, true],
  },
  {
    id: 1,
    name: "Bio",
    price: 78162,
    image: "/products/1.png",
    type: [PELLET_BOILERS, INDUSTRIAL_BOILERS],
    promotion: false,
    prices: [
      { power: "95KW", price: 78162 },
      { power: "150KW", price: 79664 },
      { power: "200KW", price: 86772 },
      { power: "250KW", price: 97534 },
      { power: "300KW", price: 122087 },
      { power: "400KW", price: 136549 },
      { power: "500KW", price: 156193 },
      { power: "600KW", price: 159201 },
      { power: "700KW", price: 162060 },
      { power: "800KW", price: 173657 },
      { power: "1000KW", price: 185527 },
      { power: "1200KW", price: 205852 },
      { power: "1500KW", price: 220647 },
    ],
    images: ["/assets/ProductImages/1/1.webp", "/assets/ProductImages/1/2.png"],
    price_details: "Pentru a comanda, verificați prețul prin telefon.",
    short_description: (
      <div>
        <p>
          BIO – cazane pe tocătura cu încărcare automată și manuală a
          combustibilului
        </p>
        <ul>
          <li>Gama largă în funcție de putere</li>
          <li>
            Catalizatori ceramică, care stabilizează procesul de ardere a
            combustibilului
          </li>
          <li>Sistem automat de stingere în caz de incendiu</li>
          <li>Fără pretenții la calitatea combustibililor</li>
          <li>
            Posibilitatea funcționării cazanului în regim manual de alimentare
          </li>
          <li>Posibilitatea schimbării poziției buncărului</li>
          <li>Posibilitatea măririi volumului buncărului</li>
        </ul>
      </div>
    ),

    parameters: [
      {
        icon: "fas fa-bolt fa-lg fa-lg",
        name: "Putere",
        stars: 5,
        details: "95 kW - 1500 kW",
      },
      {
        icon: "fas fa-star fa-lg fa-lg",
        name: "Oțel de înaltă calitate",
        stars: 4,
        details: "6 - 8 mm grosime",
      },
      {
        icon: "fas fa-fire fa-lg fa-lg",
        name: "Combustibil",
        stars: 4,
        details: "Deșeuri lemnoase, tocătura cu fracția maxima de 15х35х80 mm",
      },
      {
        icon: "fas fa-tachometer-alt fa-lg fa-lg",
        name: "Eficiență",
        stars: 5,
        details: "Minimum - 93%",
      },
    ],
    warranty_details: true,
    tabsInfo: [true, true, false],
  },
  {
    id: 2,
    name: "Bio Uni",
    price: 34643,
    image: "/products/2.png",
    type: [INDUSTRIAL_BOILERS],
    promotion: false,
    prices: [
      { power: "95 KW", price: 34643 },
      { power: "150KW", price: 36277 },
      { power: "200KW", price: 42007 },
      { power: "250KW", price: 52380 },
      { power: "300KW", price: 77204 },
      { power: "400KW", price: 96032 },
      { power: "500KW", price: 113221 },
      { power: "600KW", price: 116219 },
      { power: "700KW", price: 118813 },
      { power: "800KW", price: 129590 },
      { power: "1000KW", price: 140372 },
      { power: "1200KW", price: 160692 },
      { power: "1500KW", price: 168338 },
    ],
    images: ["/assets/ProductImages/2/1.png", "/assets/ProductImages/2/2.png"],
    price_details:
      "Pentru a comanda un model cu o capacitate de 1000 kW sau mai mare, verificați prețul prin telefon.",
    short_description: (
      <div>
        <p>
          BIO UNI – cazan cu alimentare manuala a combustibilului. Combustibili:
          antracit, carbune, lemn de foc
        </p>
        <ul>
          <li>gama larga de putere</li>
          <li>camera de ardere cu volum mare</li>
          <li>
            catalizatori ceramica, ce stabilizeaza procesul de ardere a
            combustibilului
          </li>
          <li>
            {" "}
            grilaj din fonta rezistent la temperaturi foarte mari posibilitaea
            de completare a cazanului cu un arzator cu apridere automata a
            combustibilului
          </li>
        </ul>
      </div>
    ),
    parameters: [
      {
        icon: "fas fa-bolt fa-lg",
        name: "Putere",
        stars: 5,
        details: "100 kW - 1000 kW",
      },
      {
        icon: "fas fa-star fa-lg",
        name: "Oțel de înaltă calitate",
        stars: 4,
        details: "6 - 8 mm grosime",
      },
      {
        icon: "fas fa-fire fa-lg",
        name: "Combustibili solizi",
        stars: 4,
        details: "Lemne, deşeuri de lemn, cărbune, peleţi şi brichete, turbă",
      },
      {
        icon: "fas fa-tachometer-alt fa-lg",
        name: "Eficiență",
        stars: 5,
        details: "91%",
      },
    ],
    warranty_details: true,
    tabsInfo: [true, true, false],
  },
  {
    id: 3,
    name: "Buncăr Peleți",
    price: 2884,
    image: "/products/3.png",
    type: [ACCESORIES],
    promotion: false,
    prices: [
      { power: "300L", price: 2884 },
      { power: "500L", price: 3486 },
      { power: "700L", price: 3738 },
      { power: "1000L", price: 4580 },
      { power: "1500L", price: 6247 },
      { power: "2000L", price: 11185 },
    ],
    images: [
      "/assets/ProductImages/3/1.png",
      "/assets/ProductImages/3/2.png",
      "/assets/ProductImages/3/3.png",
    ],
    price_details: "Pentru a comanda, verificați prețul prin telefon.",
    short_description: false,
    price_details: "",
    parameters: false,
    warranty_details: false,
    tabsInfo: false,
  },
  {
    id: 4,
    name: "Classic Plus",
    price: 6149,
    image: "/products/4.png",
    type: [SOLID_FUEL_BOILERS],
    promotion: false,
    prices: [
      { power: "20KW", price: 6149 },
      { power: "24KW", price: 6662 },
      { power: "30KW", price: 7174 },
      { power: "40KW", price: 8199 },
      { power: "50KW", price: 8712 },
      { power: "60KW", price: 9737 },
    ],
    price_details: false,
    images: ["/assets/ProductImages/4/1.png", "/assets/ProductImages/4/2.png"],
    short_description: (
      <div>
        <p>
          Lider în vânzări pe segmentul gospodăriei. Cazane cu combustibil solid
          pentru ardere pe termen lung pentru încălzirea locuințelor și a
          încăperilor de utilități, care combină cea mai bună valoare pentru
          bani.
        </p>
        <p>
          Classic – control mecanic al procesului de ardere utilizând
          regulatorul rotativ.
        </p>
        <p>Classic Plus – control automatizat electronic cu sistemul PID.</p>
      </div>
    ),
    parameters: [
      {
        icon: "fas fa-bolt fa-lg",
        name: "Putere",
        stars: 2,
        details: "20 kW - 60 kW",
      },
      {
        icon: "fas fa-star fa-lg",
        name: "Oțel de înaltă calitate",
        stars: 3,
        details: "5mm grosime",
      },
      {
        icon: "fas fa-fire fa-lg",
        name: "Combustibil",
        stars: 3,
        details: "Lemn, cărbune, peleți",
      },
      {
        icon: "fas fa-tachometer-alt fa-lg",
        name: "Eficiență",
        stars: 5,
        details: "Minimum - 93%",
      },
    ],
    warranty_details: true,
    tabsInfo: [true, true, false],
  },
  {
    id: 5,
    name: "Duo Pellet",
    price: 20667,
    image: "/products/5.png",
    type: [PELLET_BOILERS],
    promotion: false,
    prices: [
      { power: "17KW", price: 20667 },
      { power: "25KW", price: 22435 },
      { power: "31KW", price: 24321 },
      { power: "38KW", price: 25956 },
      { power: "50KW", price: 28523 },
      { power: "62KW", price: 32849 },
      { power: "75KW", price: 36088 },
      { power: "95KW", price: 45112 },
      { power: "120KW", price: 50330 },
      { power: "150KW", price: 52748 },
      { power: "200KW", price: 71433 },
      { power: "250KW", price: 75092 },
    ],
    images: [
      "/assets/ProductImages/5/1.png",
      "/assets/ProductImages/5/2.png",
      "/assets/ProductImages/5/3.png",
      "/assets/ProductImages/5/4.png",
    ],
    price_details: "",
    short_description: (
      <div>
        <p>
          Duo Pellet – cazan cu alimentare automată și manuală a combustibilului
        </p>
        <p>Combustibili: cărbune fin, pelete de lemn și agro pelete</p>
        <p>- eficiența foarte mare, minim 91%</p>
        <p>- cazan cu gamă largă de putere</p>
        <p>
          - camera de ardere mare cu un arzător de retorta de înaltă performanță
        </p>
        <p>- sistem automat de stingere în caz de incendiu</p>
        <p>- șnec de alimentare monolit</p>
        <p>
          - adaptat pentru a funcționa cu controlul mecanic al tirajului de aer
        </p>
        <p>
          - posibilitatea de funcționare a cazanului cu încărcare manuală a
          combustibilului, cu instalarea grătarelor din fontă rezistentă la jar
        </p>
        <p>- posibilitatea schimbării poziției buncărului</p>
        <p>- posibilitatea măririi volumului buncărului</p>
      </div>
    ),
    parameters: [
      {
        icon: "fas fa-bolt fa-lg",
        name: "Putere",
        stars: 3,
        details: "17 kW - 250 kW",
      },
      {
        icon: "fas fa-star fa-lg",
        name: "Oțel de înaltă calitate",
        stars: 3,
        details: "6mm grosime",
      },
      {
        icon: "fas fa-fire fa-lg",
        name: "Combustibil",
        stars: 4,
        details: "Cărbune fin, pelete de lemn şi agro pelete",
      },
      {
        icon: "fas fa-tachometer-alt fa-lg",
        name: "Eficiență",
        stars: 5,
        details: "Minimum - 93%",
      },
    ],
    warranty_details: true,
    tabsInfo: [true, true, false],
  },
  {
    id: 6,
    name: "Duo Pellet N",
    price: 24245,
    image: "/products/6.png",
    type: [PELLET_BOILERS],
    promotion: false,
    prices: [
      { power: "21KW", price: 24245 },
      { power: "27KW", price: 25931 },
      { power: "33KW", price: 26638 },
      { power: "40KW", price: 28806 },
      { power: "50KW", price: 31086 },
      { power: "62KW", price: 35893 },
      { power: "75KW", price: 42607 },
      { power: "95KW", price: 47353 },
      { power: "120KW", price: 55501 },
      { power: "150KW", price: 62193 },
      { power: "200KW", price: 69737 },
    ],
    images: ["/assets/ProductImages/6/1.png"],
    price_details: "",
    short_description: (
      <div>
        <p>
          Duo Pellet N – cazan cu încărcare automată și manuală a
          combustibilului
        </p>
        <p>- Eficiența foarte mare, minim 91%</p>
        <p>- cazan cu gamă largă de putere (KW)</p>
        <p>
          - camera de ardere mare cu un arzător de retorta de înaltă performanță
        </p>
        <p>- o cameră de ardere suplimentară cu alimentare manuală</p>
        <p>- grătar de apă</p>
        <p>- sistem automat de stingere în caz de incendiu</p>
        <p>
          - întreruperea parțială sau totală a centralei în cazul avariei la
          sistemul electric
        </p>
        <p>- șnec de alimentare monolit</p>
        <p>- adaptat pentru reglarea mecanică a tirajului de aer</p>
        <p>- posibilitatea schimbării poziției buncărului</p>
        <p>- posibilitatea măririi volumului buncărului</p>
      </div>
    ),
    parameters: [
      {
        icon: "fas fa-bolt fa-lg",
        name: "Putere",
        stars: 3,
        details: "21 kW - 200 kW",
      },
      {
        icon: "fas fa-star fa-lg",
        name: "Oțel de înaltă calitate",
        stars: 4,
        details: "6mm grosime",
      },
      {
        icon: "fas fa-fire fa-lg",
        name: "Combustibil",
        stars: 4,
        details: "Cărbune fin, pelete de lemn şi agro pelete",
      },
      {
        icon: "fas fa-tachometer-alt fa-lg",
        name: "Eficiență",
        stars: 5,
        details: "Minimum - 93%",
      },
    ],
    warranty_details: true,
    tabsInfo: [true, true, false],
  },
  {
    id: 7,
    name: "Duo Uni Plus",
    price: 8199,
    image: "/products/7.png",
    type: [SOLID_FUEL_BOILERS, INDUSTRIAL_BOILERS],
    promotion: false,
    prices: [
      { power: "17-21 KW", price: 8199 },
      { power: "21-27KW", price: 8865 },
      { power: "27-33KW", price: 9737 },
      { power: "33-40KW", price: 10557 },
      { power: "40-50KW", price: 11428 },
      { power: "50-62KW", price: 15220 },
      { power: "62-75KW", price: 16091 },
      { power: "75-95KW", price: 19474 },
      { power: "95-120KW", price: 25060 },
      { power: "120-150KW", price: 28493 },
      { power: "150-200KW", price: 32388 },
      { power: "200-250KW", price: 39358 },
      { power: "250-300KW", price: 46430 },
    ],
    images: [
      "/assets/ProductImages/7/1.png",
      "/assets/ProductImages/7/2.png",
      "/assets/ProductImages/7/3.png",
    ],
    price_details: "",
    short_description: (
      <div>
        <p>
          Cazane universale cu ardere lungă, cu o eficiență ridicată și
          capacitatea de a gestiona atât încărcarea manuală, cât și livrarea de
          combustibil. Designul schimbătorului de căldură este ușor de
          întreținut și oțelul de 6 mm grosime confirmă fiabilitatea și
          durabilitatea acestuia.
        </p>
      </div>
    ),
    parameters: [
      {
        icon: "fas fa-bolt fa-lg",
        name: "Putere",
        stars: 3,
        details: "21 kW - 300 kW",
      },
      {
        icon: "fas fa-star fa-lg",
        name: "Oțel de înaltă calitate",
        stars: 4,
        details: "6mm grosime",
      },
      {
        icon: "fas fa-fire fa-lg",
        name: "Combustibili solizi",
        stars: 4,
        details: "Lemne, deşeuri de lemn, cărbune, peleţi şi brichete, turbă",
      },
      {
        icon: "fas fa-tachometer-alt fa-lg",
        name: "Eficiență",
        stars: 5,
        details: "Minimum - 91%",
      },
    ],
    warranty_details: true,
    tabsInfo: [true, true, false],
  },
  {
    id: 8,
    name: "Duo Uni Pellet",
    price: 17424,
    image: "/products/8.png",
    type: [PELLET_BOILERS],
    promotion: false,
    prices: [
      { power: "17-21KW", price: 17424 },
      { power: "21-27KW", price: 18193 },
      { power: "27-33KW", price: 20191 },
      { power: "33-40KW", price: 21011 },
      { power: "40-50KW", price: 23850 },
      { power: "50-62KW", price: 29467 },
      { power: "62-75KW", price: 31773 },
      { power: "75-95KW", price: 38948 },
      { power: "95-120KW", price: 47148 },
      { power: "120-150KW", price: 56372 },
      { power: "150-200KW", price: 59960 },
      { power: "200-250KW", price: 77384 },
      { power: "250-300KW", price: 91221 },
    ],
    images: ["/assets/ProductImages/8/1.png", "/assets/ProductImages/8/2.png"],
    price_details: "",
    short_description: (
      <div>
        <p>
          Duo Uni Pellet – cazan cu alimentare automată și manuală a
          combustibilului
        </p>
        <ul>
          <li>eficiența foarte mare, minim 91%</li>
          <li>cazan cu gamă largă de putere</li>
          <li>arzător cu auto-curățare</li>
          <li>sistem de aprindere automată</li>
          <li>camera de ardere generoasă cu arzător de peleți</li>
          <li>grătar din fontă cu apă</li>
          <li>posibilitatea alimentării manuale</li>
          <li>posibilitatea programării</li>
        </ul>
      </div>
    ),
    parameters: [
      {
        icon: "fas fa-bolt fa-lg",
        name: "Putere",
        stars: 3,
        details: "15 kW - 300 kW",
      },
      {
        icon: "fas fa-star fa-lg",
        name: "Oțel de înaltă calitate",
        stars: 3,
        details: "6mm grosime",
      },
      {
        icon: "fas fa-fire fa-lg",
        name: "Combustibil",
        stars: 3,
        details: "Lemn, cărbune, peleți",
      },
      {
        icon: "fas fa-tachometer-alt fa-lg",
        name: "Eficiență",
        stars: 5,
        details: "Minimum - 93%",
      },
    ],
    warranty_details: true,
    tabsInfo: [true, true, false],
  },
  {
    id: 9,
    name: "Duo Uni Pellet Plus",
    price: 17936,
    image: "/products/9.png",
    type: [PELLET_BOILERS],
    promotion: false,
    prices: [
      { power: "17-21KW", price: 17936 },
      { power: "21-27KW", price: 18705 },
      { power: "27-33KW", price: 20704 },
      { power: "33-40KW", price: 21524 },
      { power: "40-50KW", price: 23574 },
      { power: "50-62KW", price: 30492 },
      { power: "62-75KW", price: 32798 },
      { power: "75-95KW", price: 39973 },
      { power: "95-120KW", price: 48685 },
      { power: "120-150KW", price: 57910 },
      { power: "150-200KW", price: 61497 },
      { power: "200-250KW", price: 78921 },
      { power: "250-300KW", price: 92758 },
    ],
    images: [
      "/assets/ProductImages/9/1.png",
      "/assets/ProductImages/9/2.png",
      "/assets/ProductImages/9/3.png",
      "/assets/ProductImages/9/4.png",
    ],
    price_details: "",
    short_description: (
      <div>
        <p>
          Duo Uni Pellet Plus – cazan cu alimentare automată și manuală a
          combustibilului
        </p>
        <ul>
          <li>eficiența foarte mare, minim 91%</li>
          <li>cazan cu gamă largă de putere</li>
          <li>arzător cu auto-curățare</li>
          <li>sistem de aprindere automată</li>
          <li>camera de ardere generoasă cu arzător de peleți</li>
          <li>grătar din fontă cu apă</li>
          <li>posibilitatea alimentării manuale</li>
          <li>posibilitatea programării</li>
        </ul>
      </div>
    ),
    parameters: [
      {
        icon: "fas fa-bolt fa-lg",
        name: "Catalizator",
        stars: 5,
        details: "de ceramica",
      },
      {
        icon: "fas fa-star fa-lg",
        name: "Oțel de înaltă calitate",
        stars: 3,
        details: "6mm grosime",
      },
      {
        icon: "fas fa-fire fa-lg",
        name: "Combustibil",
        stars: 3,
        details: "Lemn, cărbune, peleți",
      },
      {
        icon: "fas fa-tachometer-alt fa-lg",
        name: "Eficiență",
        stars: 5,
        details: "Minimum - 93%",
      },
    ],
    warranty_details: true,
    tabsInfo: [true, true, false],
  },
  {
    id: 10,
    name: "Max",
    price: 30963,
    image: "/products/10.png",
    type: [INDUSTRIAL_BOILERS],
    promotion: false,
    prices: [
      { power: "95KW", price: 30963 },
      { power: "150KW", price: 43099 },
      { power: "200KW", price: 45691 },
      { power: "250KW", price: 59334 },
      { power: "300KW", price: 65473 },
      { power: "400KW", price: 74339 },
      { power: "500KW", price: 86485 },
      { power: "600KW", price: 109675 },
      { power: "700KW", price: 135462 },
      { power: "800KW", price: 139958 },
    ],
    images: [
      "/assets/ProductImages/10/1.png",
      "/assets/ProductImages/10/2.png",
      "/assets/ProductImages/10/3.png",
      "/assets/ProductImages/10/4.png",
      "/assets/ProductImages/10/5.png",
      "/assets/ProductImages/10/6.png",
    ],
    price_details: "",
    short_description: (
      <div>
        <p>
          MAX – cazane industriale pe tuburi de foc cu încărcare manuală a
          combustibilului, se pot instala în containere mobile sau fixe cu
          circuit închis al sistemului de încălzire.
        </p>
        <ul>
          <li>Eficiența min 86%</li>
          <li>Gamă largă de putere</li>
          <li>Camera de ardere voluminoasă</li>
          <li>Grilaj din fontă cu apă</li>
        </ul>
        <p>
          Cazanele au putere de încălzire a spațiilor industriale și a
          clădirilor de mari dimensiuni și a altor spații, pregătind și
          furnizând căldura obținută din procesul de ardere a combustibililor
          solizi:
        </p>
        <ul>
          <li>Cărbune, cocs</li>
          <li>Lemn, masă lemnoasă, brichete</li>
          <li>Antracit, turbă și altele</li>
        </ul>
      </div>
    ),
    parameters: [
      {
        icon: "fas fa-bolt fa-lg",
        name: "Putere",
        stars: 5,
        details: "95-800 kW",
      },
      {
        icon: "fas fa-star fa-lg",
        name: "Oțel de înaltă calitate",
        stars: 5,
        details: "6-8 mm grosime",
      },
      {
        icon: "fas fa-microchip",
        name: "Control automatizat ",
        stars: 5,
        details: "Controller PID",
      },
      {
        icon: "fa-solid fa-expand",
        name: "Încăpător",
        stars: 5,
        details: "Camera de ardere voluminoasă",
      },
    ],
    warranty_details: true,
    tabsInfo: [true, true, false],
  },
  {
    id: 11,
    name: "Mega",
    price: 125096,
    image: "/products/11.png",
    type: [INDUSTRIAL_BOILERS],
    promotion: false,
    prices: [
      { power: "600KW", price: 125096 },
      { power: "800KW", price: 137779 },
      { power: "1000KW", price: 153743 },
      { power: "1200KW", price: 173381 },
      { power: "1500KW", price: 196166 },
    ],
    images: [
      "/assets/ProductImages/11/1.png",
      "/assets/ProductImages/11/2.png",
      "/assets/ProductImages/11/3.png",
      "/assets/ProductImages/11/4.png",
      "/assets/ProductImages/11/5.png",
    ],
    price_details: "",
    short_description: (
      <div>
        <p>
          MEGA – cazan universal pentru încălzirea spațiilor industriale pe
          combustibili solizi cu alimentare manuală a combustibilului
        </p>
        <ul>
          <li>gamă largă de putere</li>
          <li>volum mare al camerei de ardere</li>
          <li>grilă din țevi de fontă</li>
          <li>sistem cu alimentare are multi-punct</li>
          <li>reglarea ușilor cazanului</li>
          <li>posibilitatea de instalare a evacuării cenușii în mod automat</li>
          <li>
            posibilitatea de instalare pe cazan a unui arzător cu aprindere
            automată
          </li>
        </ul>
      </div>
    ),
    parameters: [
      {
        icon: "fas fa-bolt fa-lg",
        name: "Putere",
        stars: 5,
        details: "600-1500 kW",
      },
      {
        icon: "fas fa-star fa-lg",
        name: "Oțel de înaltă calitate",
        stars: 5,
        details: "6 - 10 mm grosime",
      },
      {
        icon: "fas fa-microchip",
        name: "Control automatizat ",
        stars: 5,
        details: "Controller PID",
      },
      {
        icon: "fas fa-tachometer-alt fa-lg",
        name: "Presiune mare",
        stars: 5,
        details: "Presiune de operare - până la 3 bar",
      },
    ],
    warranty_details: true,
    tabsInfo: [true, true, false],
  },
  {
    id: 12,
    name: "TRIO",
    price: 25915,
    image: "/products/12.png",
    type: [INDUSTRIAL_BOILERS],
    promotion: false,
    prices: [
      { power: "80KW", price: 25915 },
      { power: "97KW", price: 29600 },
      { power: "125KW", price: 41064 },
      { power: "150KW", price: 45287 },
      { power: "200KW", price: 55250 },
      { power: "250KW", price: 63024 },
      { power: "300KW", price: 79940 },
      { power: "400KW", price: 93988 },
      { power: "500KW", price: 112407 },
    ],
    images: [
      "/assets/ProductImages/12/1.png",
      "/assets/ProductImages/12/2.png",
      "/assets/ProductImages/12/3.png",
      "/assets/ProductImages/12/4.png",
      "/assets/ProductImages/12/5.png",
      "/assets/ProductImages/12/6.png",
    ],
    price_details: "Verificați prețurile prin telefon.",
    short_description: (
      <div>
        <p>
          Cazanele industriale cu combustibil solid sunt concepute pentru a
          încălzi o varietate de instalații, instalate în cazane fixe și
          transportabile. Cazanele de ardere de lungă durată, din oțel de înaltă
          calitate de 6-8 mm grosime, grătar umplut cu apă și sistem de
          alimentare cu aer multi canal, sunt capabile să funcționeze pe toate
          tipurile de combustibili solizi cunoscuți.
        </p>
      </div>
    ),
    parameters: [
      {
        icon: "fas fa-bolt fa-lg",
        name: "Putere",
        stars: 4,
        details: "80 kW - 500 kW",
      },
      {
        icon: "fas fa-star fa-lg",
        name: "Oțel de înaltă calitate",
        stars: 4,
        details: "6-8 mm grosime",
      },
      {
        icon: "fas fa-fire fa-lg",
        name: "Combustibil",
        stars: 4,
        details: "Lemn, cărbune, peleți",
      },
      {
        icon: "fas fa-tachometer-alt fa-lg",
        name: "Eficiență",
        stars: 5,
        details: "Minimum - 91%",
      },
    ],
    warranty_details: true,
    tabsInfo: [true, true, false],
  },
  {
    id: 13,
    name: "Termo-accumulator plat cu schimbătoare de căldură - TAP",
    price: 0,
    image: "/products/13.png",
    type: [BOILERS, ACCESORIES],
    promotion: false,
    prices: [
      { power: "480 L", price: 0 },
      { power: "780 L", price: 0 },
      { power: "990 L", price: 0 },
      { power: "1440 L", price: 0 },
    ],
    images: ["/assets/ProductImages/13/1.png"],
    price_details: "Pentru a comanda, verificați prețul prin telefon.",
    short_description: (
      <div>
        <ul>
          <li>economisiți spațiu</li>
          <li>ușor de montat</li>
          <li>prelucrare anticorosiva</li>
          <li>termoizolare de calitate 100mm – completare de baza</li>
          <li>presiune exercitata 6 bari</li>
        </ul>
      </div>
    ),
    parameters: false,
    warranty_details: false,
    tabsInfo: [true, false, false],
  },
  {
    id: 14,
    name: "Termo-accumulator rotund cu schimbătoare de căldură - TA1",
    price: 0,
    image: "/products/14.png",
    type: [BOILERS, ACCESORIES],
    promotion: false,
    prices: [
      { power: "480 L", price: 0 },
      { power: "780 L", price: 0 },
      { power: "990 L", price: 0 },
      { power: "1440 L", price: 0 },
      { power: "2050 L", price: 0 },
      { power: "2890 L", price: 0 },
      { power: "3875 L", price: 0 },
      { power: "4880 L", price: 0 },
      { power: "5850 L", price: 0 },
      { power: "6860 L", price: 0 },
    ],
    images: ["/assets/ProductImages/14/1.png"],
    price_details: "Pentru a comanda, verificați prețul prin telefon.",
    short_description: false,
    parameters: false,
    warranty_details: false,
    tabsInfo: false,
  },
  {
    id: 15,
    name: "Termo-accumulator rotund fără schimbător de căldură - TA0",
    price: 0,
    image: "/products/15.png",
    type: [BOILERS, ACCESORIES],
    promotion: false,
    prices: [
      { power: "480 L", price: 0 },
      { power: "780 L", price: 0 },
      { power: "990 L", price: 0 },
      { power: "1440 L", price: 0 },
      { power: "2050 L", price: 0 },
      { power: "2890 L", price: 0 },
      { power: "3875 L", price: 0 },
      { power: "4880 L", price: 0 },
      { power: "5850 L", price: 0 },
      { power: "6860 L", price: 0 },
      { power: "200 L", price: 0 },
      { power: "320 L", price: 0 },
      { power: "9850 L", price: 0 },
    ],
    images: [
      "/assets/ProductImages/15/1.png",
      "/assets/ProductImages/15/2.png",
    ],
    price_details: "Pentru a comanda un model, verificați prețul prin telefon.",
    short_description: false,
    parameters: false,
    warranty_details: false,
    tabsInfo: [true, false, false],
  },
  {
    id: 16,
    name: "Trio Pellet",
    price: 63793,
    image: "/products/16.png",
    type: [PELLET_BOILERS, INDUSTRIAL_BOILERS],
    promotion: false,
    prices: [
      { power: "150KW", price: 63793 },
      { power: "200KW", price: 77942 },
      { power: "250KW", price: 83585 },
      { power: "300KW", price: 93870 },
      { power: "400KW", price: 121062 },
      { power: "500KW", price: 154527 },
      { power: "600KW", price: 167775 },
    ],
    images: [
      "/assets/ProductImages/16/1.png",
      "/assets/ProductImages/16/2.png",
      "/assets/ProductImages/16/3.png",
      "/assets/ProductImages/16/4.png",
      "/assets/ProductImages/16/5.png",
    ],
    price_details: "",
    short_description: (
      <div>
        <p>
          TRIO Pellet – cazan industrial cu încărcare automată a combustibilului
        </p>
        <p>Combustibili: cărbune fin, pelete de lemn și agro pelete</p>
        <ul>
          <li>eficiență foarte mare, minim 91%</li>
          <li>cazan cu gamă largă de putere</li>
          <li>
            camera de ardere mare cu un arzător de retorta de înaltă performanță
          </li>
          <li>sistem automat de stingere în caz de incendiu</li>
          <li>șnec de alimentare monolit</li>
          <li>arde orice calitate de peleți</li>
          <li>posibilitatea schimbării poziției buncărului</li>
          <li>posibilitatea măririi volumului buncărului</li>
        </ul>
      </div>
    ),
    parameters: [
      {
        icon: "fas fa-bolt fa-lg",
        name: "Putere",
        stars: 4,
        details: "150 kW - 600 kW",
      },
      {
        icon: "fas fa-star fa-lg",
        name: "Oțel de înaltă calitate",
        stars: 4,
        details: "6 - 8 mm grosime",
      },
      {
        icon: "fas fa-fire fa-lg",
        name: "Combustibil",
        stars: 4,
        details: "Cărbune, pelete de lemn și agropeleți",
      },
      {
        icon: "fas fa-tachometer-alt fa-lg",
        name: "Eficiență",
        stars: 5,
        details: "Minimum - 93%",
      },
    ],
    warranty_details: true,
    tabsInfo: [true, true, false],
  },
  {
    id: 17,
    name: "Trio Uni Pellet",
    price: 18039,
    image: "/products/17.png",
    type: [PELLET_BOILERS],
    promotion: false,
    prices: [
      { power: "14-20KW", price: 18039 },
      { power: "20-30KW", price: 18398 },
      { power: "30-40KW", price: 21011 },
      { power: "40-50KW", price: 23830 },
      { power: "50-65KW", price: 29928 },
      { power: "65-80KW", price: 32798 },
      { power: "80-97KW", price: 39973 },
      { power: "97-150KW", price: 47916 },
      { power: "150-200KW", price: 61497 },
      { power: "200-250KW", price: 78921 },
      { power: "250-300KW", price: 94808 },
    ],
    images: [
      "/assets/ProductImages/17/1.png",
      "/assets/ProductImages/17/2.png",
      "/assets/ProductImages/17/3.png",
      "/assets/ProductImages/17/4.png",
    ],
    price_details:
      "Pentru a comanda un model cu o capacitate de 300 kW sau mai mare, verificați prețul prin telefon.",
    short_description: (
      <div>
        <p>
          Trio Uni Pellet – cazan cu încărcare automatizată și manuală fără
          catalizator ceramic
        </p>
        <ul>
          <li>eficiență foarte mare, minim 91%</li>
          <li>arzător cu auto-curățare</li>
          <li>sistem de aprindere automată a combustibilului</li>
          <li>camera de ardere generoasă cu arzător de peleți</li>
          <li>
            catalizator de ceramică, stabilizează procesul de ardere a
            combustibilului
          </li>
          <li>grătar din fontă cu apă</li>
          <li>posibilitatea alimentare manuală</li>
          <li>posibilitatea programării</li>
        </ul>
      </div>
    ),
    parameters: [
      {
        icon: "fas fa-bolt fa-lg",
        name: "Putere",
        stars: 4,
        details: "20 kW - 700 kW",
      },
      {
        icon: "fas fa-star fa-lg",
        name: "Oțel de înaltă calitate",
        stars: 4,
        details: "8 mm grosime",
      },
      {
        icon: "fas fa-fire fa-lg",
        name: "Combustibil",
        stars: 4,
        details: "Lemn, cărbune, peleți",
      },
      {
        icon: "fas fa-tachometer-alt fa-lg",
        name: "Eficiență",
        stars: 5,
        details: "Minimum - 93%",
      },
    ],
    warranty_details: true,
    tabsInfo: [true, true, false],
  },
  {
    id: 18,
    name: "Trio Uni Pellet Plus",
    price: 18551,
    image: "/products/18.png",
    type: [PELLET_BOILERS],
    promotion: false,
    prices: [
      { power: "14-20KW", price: 18551 },
      { power: "20-30KW", price: 18910 },
      { power: "30-40KW", price: 21524 },
      { power: "40-50KW", price: 24342 },
      { power: "50-65KW", price: 30953 },
      { power: "65-80KW", price: 33823 },
      { power: "80-97KW", price: 40998 },
      { power: "97-150KW", price: 49454 },
      { power: "150-200KW", price: 63034 },
      { power: "200-250KW", price: 79895 },
      { power: "250-300KW", price: 96346 },
    ],
    images: [
      "/assets/ProductImages/18/1.png",
      "/assets/ProductImages/18/2.png",
      "/assets/ProductImages/18/3.png",
      "/assets/ProductImages/18/4.png",
    ],
    price_details:
      "Pentru a comanda un model cu o capacitate de 300 kW sau mai mare, verificați prețul prin telefon.",
    short_description: (
      <div>
        <p>
          Trio Uni Pellet Plus – cazan cu încărcare automatizată și manuală cu
          catalizator ceramic
        </p>
        <ul>
          <li>eficiență foarte mare, minim 91%</li>
          <li>arzător cu auto-curățare</li>
          <li>sistem de aprindere automată a combustibilului</li>
          <li>camera de ardere generoasă cu arzător de peleți</li>
          <li>
            catalizator de ceramică, stabilizează procesul de ardere a
            combustibilului
          </li>
          <li>grătar din fontă cu apă</li>
          <li>posibilitatea alimentare manuală</li>
          <li>posibilitatea programării</li>
        </ul>
      </div>
    ),
    parameters: [
      {
        icon: "fas fa-bolt fa-lg",
        name: "Putere",
        stars: 4,
        details: "14 kW - 300 kW",
      },
      {
        icon: "fas fa-star fa-lg",
        name: "Oțel de înaltă calitate",
        stars: 4,
        details: "8 mm grosime",
      },
      {
        icon: "fas fa-fire fa-lg",
        name: "Combustibil",
        stars: 4,
        details: "Lemn, cărbune, peleți",
      },
      {
        icon: "fas fa-tachometer-alt fa-lg",
        name: "Eficiență",
        stars: 5,
        details: "Minimum - 93%",
      },
    ],
    warranty_details: true,
    tabsInfo: [true, true, false],
  },
  {
    id: 19,
    name: "Trio Uni Plus",
    price: 7738,
    image: "/products/19.png",
    type: [SOLID_FUEL_BOILERS, INDUSTRIAL_BOILERS],
    promotion: false,
    prices: [
      { power: "14-20KW", price: 7738 },
      { power: "20-30KW", price: 8045 },
      { power: "30-40KW", price: 9685 },
      { power: "40-50KW", price: 12094 },
      { power: "50-65KW", price: 14246 },
      { power: "65-80KW", price: 16758 },
      { power: "80-97KW", price: 20499 },
      { power: "97-150KW", price: 25418 },
      { power: "150-200KW", price: 32696 },
      { power: "200-250KW", price: 39460 },
      { power: "250-300KW", price: 49915 },
      { power: "300-400KW", price: 53964 },
      { power: "400-500KW", price: 69543 },
      { power: "500-600KW", price: 86762 },
      { power: "600-700KW", price: 91118 },
    ],
    images: [
      "/assets/ProductImages/19/1.PNG",
      "/assets/ProductImages/19/2.webp",
      "/assets/ProductImages/19/3.png",
      "/assets/ProductImages/19/4.png",
    ],
    price_details: "Verificați prețurile prin telefon.",
    short_description: (
      <div>
        <p>
          TRIO UNI – reglarea mecanică a procesului de ardere cu ajutorul
          mânerului rotativ 20 – 40 kW
        </p>
        <p>
          TRIO UNI Plus – reglarea electrică a funcției cazanului cu PID 20 – 80
          kW
        </p>
        <ul>
          <li>
            utilizarea tehnologiei de ardere superioară asigură o eficiență
            ridicată a cazanului, la un nivel care nu scade sub eficiența de 86%
          </li>
          <li>camera mare de ardere</li>
          <li>grătar de apă din fontă</li>
          <li>
            adaptat din fabrică pentru instalarea sistemului de presurizare
          </li>
          <li>sistem multi-punct de alimentare cu aer</li>
          <li>reglarea ușoară a ușii</li>
          <li>
            posibilitatea de instalare a unui arzător cu alimentare automată,
            autoaprindere și auto-curățare
          </li>
        </ul>
      </div>
    ),
    parameters: [
      {
        icon: "fas fa-bolt fa-lg",
        name: "Putere",
        stars: 4,
        details: "20 kW - 700 kW",
      },
      {
        icon: "fas fa-star fa-lg",
        name: "Oțel de înaltă calitate",
        stars: 4,
        details: "6 - 8 mm grosime",
      },
      {
        icon: "fas fa-fire fa-lg",
        name: "Combustibil",
        stars: 4,
        details: "Cărbune fin, pelete de lemn şi agro pelete",
      },
      {
        icon: "fas fa-tachometer-alt fa-lg",
        name: "Eficiență",
        stars: 5,
        details: "Minimum - 93%",
      },
    ],
    warranty_details: true,
    tabsInfo: [true, true, false],
  },
  {
    id: 20,
    name: "Turbo",
    price: 7117,
    image: "/products/20.png",
    type: [SOLID_FUEL_BOILERS, PELLET_BOILERS],
    promotion: false,
    prices: [
      { power: "10KW", price: 7117 },
      { power: "15KW", price: 8106 },
      { power: "20KW", price: 9065 },
      { power: "25KW", price: 10044 },
      { power: "35KW", price: 10864 },
      { power: "50KW", price: 14071 },
    ],
    images: [
      "/assets/ProductImages/20/1.png",
      "/assets/ProductImages/20/2.png",
      "/assets/ProductImages/20/3.png",
      "/assets/ProductImages/20/4.png",
    ],
    price_details: "",
    short_description: (
      <div>
        <p>
          Aceste cazane cu ardere îndelungată sunt destinate încălzirii
          spațiilor de producție mici, pensiunilor și caselor.
        </p>
        <ul>
          <li>20 kW (încălzește suprafața până la 200m²)</li>
          <li>35 kW (încălzește suprafața până la 350m²)</li>
          <li>50 kW (încălzește suprafața până la 500m²)</li>
        </ul>
        <p>Prețurile includ automatizarea corespunzătoare și ventilator.</p>
      </div>
    ),
    parameters: [
      {
        icon: "fas fa-bolt fa-lg",
        name: "Putere",
        stars: 3,
        details: "12 kW - 50 kW",
      },
      {
        icon: "fas fa-star fa-lg",
        name: "Oțel de înaltă calitate",
        stars: 3,
        details: "5mm grosime",
      },
      {
        icon: "fas fa-microchip",
        name: "Control automatizat",
        stars: 3,
        details: "Controller PID",
      },
      {
        icon: "fas fa-tachometer-alt fa-lg",
        name: "Eficiență",
        stars: 5,
        details: "Minimum - 93%",
      },
    ],
    warranty_details: true,
    tabsInfo: [true, true, false],
  },
  {
    id: 21,
    name: "Altep Pellets",
    price: 16911,
    image: "/products/21.png",
    type: [PELLET_BOILERS],
    promotion: false,
    prices: [
      { power: "33KW", price: 16911 },
      { power: "40KW", price: 18961 },
      { power: "50KW", price: 20499 },
    ],
    images: [
      "/assets/ProductImages/21/1.png",
      "/assets/ProductImages/21/2.png",
    ],
    price_details: "",
    short_description: (
      <div>
        <p>
          Lider în vânzări pe segmentul gospodăriei. Cazane cu combustibil solid
          pentru ardere pe termen lung pentru încălzirea locuințelor și a
          încăperilor de utilități, care combină cea mai bună valoare pentru
          bani.
        </p>
      </div>
    ),
    parameters: [
      {
        icon: "fas fa-bolt fa-lg",
        name: "Putere",
        stars: 3,
        details: "33 kW - 50 kW",
      },
      {
        icon: "fas fa-star fa-lg",
        name: "Oțel de înaltă calitate",
        stars: 3,
        details: "5mm grosime",
      },
      {
        icon: "fas fa-fire fa-lg",
        name: "Сombustibil",
        stars: 3,
        details: "Peleti",
      },
      {
        icon: "fas fa-tachometer-alt fa-lg",
        name: "Eficiență",
        stars: 5,
        details: "Minimum - 91%",
      },
    ],
    warranty_details: true,
    tabsInfo: [true, true, false],
  },
  {
    id: 22,
    name: "AGRO",
    price: 74309,
    image: "/products/22.png",
    type: [INDUSTRIAL_BOILERS],
    promotion: false,
    prices: [
      { power: "150 - 300 kW", price: 74309 },
      { power: "300 - 600 kW", price: 169118 },
    ],
    images: [
      "/assets/ProductImages/22/1.png",
      "/assets/ProductImages/22/2.png",
      "/assets/ProductImages/22/3.png",
    ],
    price_details: "",
    short_description: (
      <div>
        <p>
          AGRO – cazan industrial cu tuburi de foc cu alimentare manuala, care
          poate fi instalat în module mobile cat și în cele fixe cu circuit
          închis al sistemului de încălzire. Cazanul este prevăzut sa
          încălzească spații menajere, industriale și alte locații de dimensiuni
          mari pregătind și furnizând căldura în timpul arderii baloților de
          paie.
        </p>
      </div>
    ),
    parameters: [
      {
        icon: "fas fa-bolt fa-lg",
        name: "Putere",
        stars: 5,
        details: "33 kW - 50 kW",
      },
      {
        icon: "fas fa-star fa-lg",
        name: "Oțel de înaltă calitate",
        stars: 5,
        details: "5mm grosime",
      },
      {
        icon: "fa-solid fa-microchip fa-lg",
        name: "Control automatizat ",
        stars: 5,
        details: "Peleti",
      },
      {
        icon: "fa-solid fa-expand fa-lg",
        name: "Încăpător",
        stars: 5,
        details: "Minimum - 91%",
      },
    ],
    warranty_details: true,
    tabsInfo: [true, true, false],
  },
];
